/* eslint-disable react/prop-types */
import React, { useEffect } from 'react';
import './User.scss';

export default function User({
  id, name, email, status,
}) {
  useEffect(() => {}, []);

  return (
    <section className="User">
      <div>
        <span>{` ${id}`}</span>
        <span>{` ${name}`}</span>
        <span>{` ${email}`}</span>
        <span>{` ${status}`}</span>
      </div>
    </section>
  );
}
